export const BREAK_POINT = 750;

// export const PINTO_EVENT_API = 'https://service.plan-b.co.jp/wp-json/wp/v2/event/?_embed&per_page=50';
